import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ReportActionCreators } from '@nkr/store/index';
import { ICprScoreResponse } from '@nkr/store/reports';
import { ScoresReport } from './scores-report';

interface IProps {
    allCenters: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getFcrScores: (month: number, year: number) => Promise<ICprScoreResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const FcrScoresReportPage = (props: TProps) => {
    return (
        <ScoresReport
            allCenters={props.allCenters}
            title='Center Favorable Compatible Ratio (FCR) Scores'
            showFcr={true}
            lookbackMonths={12}
            fileName='center-fcr-scores-using-data-last-12-months.csv'
            loadingMessage='Getting FCR scores, one moment please...'
            showLoading={props.showLoading}
            hideLoading={props.hideLoading}
            getScores={props.getFcrScores}
        />
    );
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getFcrScores: (month, year) => {
            return dispatch(ReportActionCreators.getFcrScores(month, year));
        }
    };
}

export const FcrScoresReport = connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FcrScoresReportPage);
